import { getUserActiveModules } from 'pathfinder/utils/shareState/getUserActiveModules';
export const getShareState = () => ({
    activeModules: getUserActiveModules(),
});
